<header ng-class="{'no-header': widget.noHeader}" class="property-group-header">
    <h2><a ui-sref="{{widget.sourceState || 'start.content'}}">{{widget.title | translate}}</a></h2>
    <ul>
        <li class="buttons settings" ng-click="toggleSettings()">&#x22EE;</li>
    </ul>
</header>
